import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { ONLY_MONTH_FORMAT } from '../../constants/global'
import dayjs, { Dayjs } from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { RiDownload2Line } from 'react-icons/ri'

interface Props {
  onClose: (visible: boolean) => void
  isOpen: boolean
  onDownload?: (date: Dayjs) => void
  filterDate?: boolean
}

const ExcelModal = (props: Props) => {
  const { onClose, isOpen, onDownload, filterDate } = props
  const [loading, setLoading] = useState(false)
  const [date, setDate] = useState<Dayjs>(dayjs())

  useEffect(() => {
    setLoading(false)
  }, [isOpen])

  const handleOnDownload = () => {
    setLoading(true)
    onDownload?.(date)
    onClose(true)
    // setLoading(false)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose(false)}
      fullWidth
      maxWidth={filterDate ? 'sm' : 'xs'}
    >
      <DialogTitle>ดาวน์โหลด Excel</DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={2}
          justifyContent={'center'}
          alignItems={'center'}
        >
          {filterDate && (
            <Grid item xs={12} lg={8}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format={ONLY_MONTH_FORMAT}
                  // disableFuture
                  label="เลือก เดือน/ปี"
                  value={date ? dayjs(date) : null}
                  onChange={(e) => {
                    setLoading(false)
                    setDate(dayjs(e!))
                  }}
                  views={['month', 'year']}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>
          )}
          <Grid item xs={12} lg={filterDate ? 4 : 12}>
            <Button
              fullWidth
              disabled={loading}
              variant="contained"
              color="primary"
              size="large"
              startIcon={<RiDownload2Line />}
              onClick={() => {
                handleOnDownload()
              }}
            >
              ดาวน์โหลดทันที
            </Button>
          </Grid>
          {filterDate && (
            <Grid item xs={12} lg={12}>
              <Typography variant="caption" color="textSecondary">
                หมายเหตุ: หากวันที่ที่คุณเลือกในการค้นหา มากกว่า 1 เดือน
                ระบบจะดาวน์โหลดข้อมูลทั้งหมดของเดือนในช่องเลือก "เดือน/ปี"
                (ข้างบน) แทน แต่หากเลือกช่วงเวลาวันที่ไม่เกิน 1 เดือน
                ระบบจะดาวน์โหลดข้อมูลตามที่แสดงผลบนเว็บไซต์
              </Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ExcelModal
